import headersDB from '../../lib/gqlDB/headers';
import { displayActions } from '../slices/display';
import { workspaceActions } from '../slices/workspace';

export const saveHeaders = headers => dispatch => {
    dispatch(workspaceActions.SUBMITTING_DATA());

    return headersDB
        .updateHeaders(headers)
        .then(() => {
            dispatch(workspaceActions.REQUEST_HEADERS({headers}));
            dispatch(displayActions.TOGGLE_MANAGE_REQUEST_HEADERS_DIALOG());
        })
        .catch(error => dispatch(workspaceActions.ACTION_ERROR(error)));
};

export const loadHeaders = () => dispatch => {
    dispatch(workspaceActions.SUBMITTING_DATA());

    return headersDB.getHeaders()
        .then(headers => {
            dispatch(workspaceActions.REQUEST_HEADERS_LOADED({headers}));
        })
        .catch(error => dispatch(workspaceActions.ACTION_ERROR(error)));
};